<div class="bb-stack border-bottom-selector beneficiary-selector-ui__beneficiary-contact">
    <div class="text-left">
        <div class="bb-text-bold" data-role="beneficiary-account-name-list-item">
            {{ catalog?.desc }} - {{ catalog?.id }}
        </div>
    </div>
</div>
